
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"グループ 232","transform":"translate(-3400 886)"}},[_c('circle',{attrs:{"data-name":"楕円形 2","cx":"16","cy":"16","r":"16","transform":"translate(3400 -886)","fill":"#47a663"}}),_c('path',{attrs:{"d":"M3423-862.8h-14v-9.9h14m0-4.5h-1v-1.8h-2v1.8h-8v-1.8h-2v1.8h-1a1.907 1.907 0 00-2 1.8v12.6a1.908 1.908 0 002 1.8h14a1.908 1.908 0 002-1.8v-12.6a1.908 1.908 0 00-2-1.8m-2.47 7.254l-1.06-.954-4.88 4.392-2.12-1.908-1.06.954 3.18 2.862z","fill":"#fff"}})])])
          )
        }
      }
    